import { render, staticRenderFns } from "./DeliverySetting.vue?vue&type=template&id=1c28588a&scoped=true&"
import script from "./DeliverySetting.vue?vue&type=script&lang=js&"
export * from "./DeliverySetting.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySetting.vue?vue&type=style&index=0&id=1c28588a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c28588a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCard,VDataTable})
